export default "__VITE_ASSET__Bkphe8tQ__"